export const A3 = [11.7, 16.5];
export const A4 = [8.27, 11.7];
export const A5 = [5.8, 8.3];
export const A6 = [4.1, 5.8];
export const LETTER = [8.5, 11];
export const LEGAL = [8.5, 14];
export const TABLOID = [11, 17];
export const NO_MARGINS = [0, 0, 0, 0];
export const NORMAL_MARGINS = [1, 1, 1, 1];
export const LARGE_MARGINS = [2, 2, 2, 2];
